export const FETCH_NOTIFICATION_CONFIGS_REQUEST = 'loyalty/notifications/FETCH_NOTIFICATION_CONFIGS_REQUEST';
export const FETCH_NOTIFICATION_CONFIGS_SUCCESS = 'loyalty/notifications/FETCH_NOTIFICATION_CONFIGS_SUCCESS';
export const FETCH_NOTIFICATION_CONFIGS_FAILURE = 'loyalty/notifications/FETCH_NOTIFICATION_CONFIGS_FAILURE';

export const UPDATE_NOTIFICATION_CONFIG_REQUEST = 'loyalty/notifications/UPDATE_NOTIFICATION_CONFIG_REQUEST';
export const UPDATE_NOTIFICATION_CONFIG_SUCCESS = 'loyalty/notifications/UPDATE_NOTIFICATION_CONFIG_SUCCESS';
export const UPDATE_NOTIFICATION_CONFIG_FAILURE = 'loyalty/notifications/UPDATE_NOTIFICATION_CONFIG_FAILURE';
